const SEGMENTS = ["#6366F1", "#06B6D4", "#10B981", "#F59E0B"];

export const LogoMark = ({ className = "h-9 w-9", check = "#F8FAFC" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="logo-mark">
    {SEGMENTS.map((c, i) => (
      <circle key={c} cx="50" cy="50" r="36" fill="none" stroke={c} strokeWidth="12" strokeDasharray="50.27 175.93" transform={`rotate(${-85 + i * 90} 50 50)`} />
    ))}
    <path d="M34 51 L45 62 L67 39" fill="none" stroke={check} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
